/*
 * American Fur — dedicated collection page template behavior.
 * Loaded with `defer` only on templates/collection.american-fur.json.
 * Progressive enhancement only: every filter/sort/pagination control is a real link or a
 * real GET form field, so the page works with JS disabled. This script upgrades those same
 * controls to fetch-and-swap instead of a full page reload.
 */
document.documentElement.classList.add('js');

(function () {
  'use strict';

  var DEBOUNCE_MS = 400;

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(null, args); }, wait);
    };
  }

  function getApp() {
    return document.querySelector('.af-coll__app');
  }

  function swap(url, updateHistory) {
    var app = getApp();
    if (!app) return;

    if (updateHistory === undefined) updateHistory = true;

    var sectionId = app.getAttribute('data-section-id');
    var separator = url.indexOf('?') === -1 ? '?' : '&';
    var fetchUrl = url + separator + 'section_id=' + sectionId;

    app.classList.add('is-loading');

    fetch(fetchUrl)
      .then(function (response) { return response.text(); })
      .then(function (text) {
        var parsed = new DOMParser().parseFromString(text, 'text/html');
        var newApp = parsed.querySelector('.af-coll__app');
        app.classList.remove('is-loading');

        // The response isn't a collection render (e.g. a product URL): fall back to a
        // real navigation rather than silently leaving the grid dimmed and unclickable.
        if (!newApp) { window.location.href = url; return; }

        app.innerHTML = newApp.innerHTML;
        if (updateHistory) history.pushState({ afCollectionUrl: url }, '', url);

        if (window.jdgm && typeof window.jdgm.batchRelayoutWidgets === 'function') {
          window.jdgm.batchRelayoutWidgets();
        }
      })
      .catch(function () {
        app.classList.remove('is-loading');
        window.location.href = url;
      });
  }

  function formToUrl(form) {
    var params = new URLSearchParams(new FormData(form));
    var base = form.getAttribute('action') || window.location.pathname;
    var query = params.toString();
    return query ? base + '?' + query : base;
  }

  var submitDebounced = debounce(function (form) {
    swap(formToUrl(form));
  }, DEBOUNCE_MS);

  document.addEventListener('change', function (event) {
    var app = getApp();
    if (!app || !app.contains(event.target)) return;

    var form = event.target.closest('form');
    if (!form) return;

    if (event.target.matches('select, input[type="checkbox"]')) {
      swap(formToUrl(form));
    }
  });

  document.addEventListener('input', function (event) {
    var app = getApp();
    if (!app || !app.contains(event.target)) return;
    if (!event.target.matches('input[type="number"]')) return;

    var form = event.target.closest('form');
    if (!form) return;
    submitDebounced(form);
  });

  document.addEventListener('submit', function (event) {
    var app = getApp();
    if (!app || !app.contains(event.target)) return;
    event.preventDefault();
    swap(formToUrl(event.target));
  });

  document.addEventListener('click', function (event) {
    // Opt-in only. This used to match every <a> inside .af-coll__app, which swallowed
    // product-card clicks and swapped a product URL into the grid.
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    var link = event.target.closest('a.af-coll__page-link, a[data-coll-swap]');
    if (!link) return;
    var app = getApp();
    if (!app || !app.contains(link)) return;
    if (link.target === '_blank' || link.hasAttribute('download')) return;

    var href = link.getAttribute('href');
    if (!href || href.charAt(0) === '#') return;

    event.preventDefault();
    swap(href);
  });

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-coll-filters-open]');
    var close = event.target.closest('[data-coll-filters-close]');
    var sidebar = document.querySelector('.af-coll__sidebar');
    var backdrop = document.querySelector('.af-coll__sidebar-backdrop');
    if (!sidebar) return;

    if (toggle) {
      sidebar.classList.add('is-open');
      if (backdrop) backdrop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    } else if (close || (backdrop && event.target === backdrop)) {
      sidebar.classList.remove('is-open');
      if (backdrop) backdrop.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  });

  window.addEventListener('popstate', function () {
    swap(window.location.href, false);
  });
})();
